import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './View.css';

const View = ({ currentPath }) => {
    const gridViewClass = `link is-hidden-touch ${currentPath === '/' || currentPath === '' ? 'active' : ''}`;
    const listViewClass = `link is-hidden-desktop ${currentPath === '/list' ? 'active' : ''}`;
    const mapViewClass = `link ${currentPath === '/map' ? 'active' : ''}`;

    return (
        <div className="link-wrapper">
            <Link path="/office/" className={gridViewClass} to="/office/">
                <svg id="grid-icon" className="icon" data-name="grid-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.77 8.94">
                    <title>grid-icon</title>
                    <rect y="5.58" width="3.36" height="3.36" fill="#c7c8c9" />
                    <rect x="5.41" y="5.58" width="3.36" height="3.36" fill="#c7c8c9" />
                    <rect width="3.36" height="3.36" fill="#c7c8c9" />
                    <rect x="5.41" width="3.36" height="3.36" fill="#c7c8c9" />
                </svg>
                <span>GRID</span>
            </Link>
            <Link to="/office/list" className={listViewClass}>
                <svg id="list-icon" className="icon" viewBox="0 0 9.99 9.02" xmlns="http://www.w3.org/2000/svg">
                    <title>list-icon</title>
                    <g fill="#c7c8c9">
                        <path d="m0 0h1.84v2.27h-1.84z" />
                        <path d="m2.83 0h7.16v2.27h-7.16z" />
                        <path d="m0 3.43h1.84v2.27h-1.84z" />
                        <path d="m2.83 3.43h7.16v2.27h-7.16z" />
                        <path d="m0 6.76h1.84v2.27h-1.84z" />
                        <path d="m2.83 6.76h7.16v2.27h-7.16z" />
                    </g>
                </svg>
                <span>LIST</span>
            </Link>
            <Link to="/office/map" className={mapViewClass}>
                <svg id="map-icon" className="icon" data-name="map-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.47 10.23">
                    <title>map-icon</title>
                    <path d="M215.17,224.06a4.24,4.24,0,0,0-6,6l3,3,3-3A4.24,4.24,0,0,0,215.17,224.06Zm-3,4.57a1.67,1.67,0,1,1,1.67-1.67A1.68,1.68,0,0,1,212.18,228.63Z" transform="translate(-207.94 -222.82)" fill="#c7c8c9" />
                </svg>
                <span>MAP</span>
            </Link>
        </div>
    );
};

View.propTypes = {
    currentPath: PropTypes.string.isRequired,
};

export default View;
